import React from "react";

interface IconProps {
  name: string; // iconfont 图标名，比如 "xiaohongshu"
  className?: string; // tailwind 样式
}

const Icon: React.FC<IconProps> = ({ name, className = "" }) => {
  return (
    <svg className={`icon ${className} `} aria-hidden="true">
      <use xlinkHref={`#${name}`} fill="currentColor" />
    </svg>
  );
};

export default Icon;
